import { isEmpty, mountComponent } from '@/utils';
import { Error, LoadingContainer } from '@/components/shared';
import { Recreation } from '@/types';
import React, { useEffect, useState } from 'react';
import { RecreationItem } from './recreationItem';
import { useRecreations } from '../../hooks';

const RECREATIONS_FETCH_FAILED_MESSAGE =
  'レク一覧の取得に失敗しました。ページを再読み込みしてお試しください。';

const RecreationIndex: React.FC = () => {
  const [recreations, setRecreations] = useState<Array<Recreation>>([]);
  const [errors, setErrors] = useState<Array<string>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { fetchRecreations } = useRecreations();

  useEffect(() => {
    (async () => {
      try {
        const recreationsResponse = await fetchRecreations();
        setRecreations([...recreationsResponse]);
      } catch (e) {
        console.error(RECREATIONS_FETCH_FAILED_MESSAGE, e);
        setErrors([RECREATIONS_FETCH_FAILED_MESSAGE]);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [fetchRecreations]);

  if (isLoading) {
    return <LoadingContainer />;
  }

  return (
    <div>
      {!isEmpty(errors) && <Error errors={errors} />}
      {recreations.map((recreation) => (
        <RecreationItem key={recreation.id} recreation={recreation} />
      ))}
      {isEmpty(errors) && isEmpty(recreations) && (
        <div className='m-3'>
          <p>まだ登録中のレクはありません</p>
        </div>
      )}
      <div className='m-3'>
        <a
          href='/partners/recreations/new'
          className='btn btn-primary btn-lg btn-block w-100 p-3 mb-2 text-white'
        >
          新規レクを追加
        </a>
      </div>
    </div>
  );
};

mountComponent('#recreationIndex', () => <RecreationIndex />);
